import React from 'react';
import ClearFacetsButton from '../../search-page-resources/jsx/ClearFacetsButton';
import toKebabCase from '../../_global/js/stringToKebab';
import FacetAccordion from '../../facet-rse/jsx/FacetAccordion';

const DesktopFacets = ({
    searchFacetSelections,
    SEARCH_FACET_OPTIONS,
    generateFacetTags,
    searchContentRef,
}) => {
    return (
        <fieldset>
            <div className="search-page-resources__left-menu-header">
                <legend className="search-page-resources__menu-title">
                    Filter
                </legend>

                {Object.entries(searchFacetSelections).length !== 0 ? (
                    <ClearFacetsButton />
                ) : null}
            </div>

            {generateFacetTags()}

            <div className="search-page-resources__left-menu-facets">
                {SEARCH_FACET_OPTIONS.map((facetData) => {
                    return (
                        <FacetAccordion
                            key={toKebabCase(facetData.name)}
                            facetTitle={facetData.name}
                            facetKey={facetData.name}
                            facetParamName={facetData.queryStringParamName}
                            searchContentRef={searchContentRef}
                        />
                    );
                })}
            </div>
        </fieldset>
    );
};

export default DesktopFacets;
